import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const user = useSelector((state) => state.auth.user);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  if (!user || !isAuthenticated) {
    return <Navigate to="/user/login" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;